import styled from "styled-components";

export const DetailHeader = styled.div`
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    padding-bottom: 16px;
`;

export const DetailHeaderContainer = styled.div`
    gap: 10px;
    padding-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const DetailHeaderItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0px;
    }
`;

export const SubcompanyInputContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 200px;
    gap: 5px;

    @media (max-width: 768px) {
        min-width: 100%;
    }
`;

export const DateRangeContainer = styled.div`
    flex-direction: column;
    display: flex;
    align-items: flex-start;
    margin: 30px 0;
    gap: 5px;

    @media (max-width: 768px) {
        min-width: 100%;
    }
`;

export const ExcelButtonContainer = styled.div`
    margin-top: 22px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const CariFiltersWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
    margin: 30px 0;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
    }
`;

export const CariFilterItem = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (max-width: 768px) {
        width: 100%;
        flex: none;

        .ant-picker,
        .ant-select,
        .ant-input-group-wrapper,
        .ant-input-search,
        .ant-input {
            width: 100% !important;
        }
    }
`;

export const CariExcelButtonWrapper = styled.div`
    margin-top: 15px;

    @media (max-width: 768px) {
        margin-top: 0;
        width: 100%;

        button {
            width: 100%;
        }
    }
`;
